// src/components/Public/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ t, language, scrollToSection }) => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-col branding">
          <div className="logo-text">CSR <span>Claims Assistant</span></div>
          <p>{t.footerDesc}</p>
          <div className="social-links">
            <a href="https://www.instagram.com/csrclaimsassistant" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram" aria-hidden="true"></i></a>
            <a href="https://www.linkedin.com/company/csr-claims-assistant/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="fab fa-linkedin-in" aria-hidden="true"></i></a>
            <a href="https://www.facebook.com/csrclaimsassistant/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook-f" aria-hidden="true"></i></a>
          </div>
        </div>
        <div className="footer-col">
          <h4 aria-level={2}>{language === 'es' ? 'Explorar' : 'Explore'}</h4>
          <ul>
            <li><button onClick={() => scrollToSection('inicio')} className="footer-link-btn">{t.nav[0]}</button></li>
            <li><button onClick={() => scrollToSection('servicios')} className="footer-link-btn">{t.nav[1]}</button></li>
            <li><button onClick={() => scrollToSection('quienes')} className="footer-link-btn">{t.nav[2]}</button></li>
            <li><Link to="/claim-status">{t.claimStatus}</Link></li>
            <li><button onClick={() => scrollToSection('contacto')} className="footer-link-btn">{t.nav[5]}</button></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4 aria-level={2}>{language === 'es' ? 'Contacto' : 'Contact'}</h4>
          <ul className="contact-list">
            <li><i className="fa-solid fa-phone"></i> <a href="tel:4072790703">(407) 279-0703</a></li>
            <li><i className="fa-solid fa-envelope"></i> <a href="mailto:info@csrclaimsassistant.com">info@csrclaimsassistant.com</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4 aria-level={2}>{language === 'es' ? 'Novedades' : 'Updates'}</h4>
          <p>{language === 'es' ? 'Para recibir novedades de CSR, escríbenos y te contestamos directamente.' : 'To get news from CSR, write to us and we will reply directly.'}</p>
          <p><a href="mailto:info@csrclaimsassistant.com">info@csrclaimsassistant.com</a></p>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="copyright">&copy; 2026 CSR Claims Assistant. {language === 'es' ? 'Todos los derechos reservados.' : 'All rights reserved.'}</p>
        <div className="footer-legal">
          <a className="footer-legal-btn" href={language === 'es' ? '/privacy.html' : '/privacy-en.html'}>{language === 'es' ? 'Privacidad' : 'Privacy'}</a>
          <a className="footer-legal-btn" href={language === 'es' ? '/terms.html' : '/terms-en.html'}>{language === 'es' ? 'Términos' : 'Terms'}</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
